import faqData, { faqTipsData } from "constants-lib/seo/faqMovingData"
import {
  addJSONLDToHead,
  removeElement,
  getSchemaFormattedData,
} from "./jsonLD.js"

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addFaqMoveJSONLD = () => {
  if (
    window.location.href.includes(`/cpn/moving`) &&
    document.getElementById(`faqJSONLD`) === null
  ) {
    const faq = window.location.href.includes(`/cpn/moving/tips-resources`)
      ? faqTipsData
      : faqData
    const script = faqMoveJSONLD(faq)
    addJSONLDToHead(script, `faqJSONLD`)
  } else {
    removeElement(`faqJSONLD`)
  }
}

// JSON LD template for FAQ Move
const faqMoveJSONLD = (d) => {
  const FaqMoveTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getSchemaFormattedData(d),
  }
  return FaqMoveTemplate
}
